/* GeoCity — подпись места на карте: какой город здесь, на языке страницы.
 *
 * Один владелец на все карты сайта (пожары, ветер, спутники, засветка, Солнце
 * и Луна, сияния, землетрясения, затмения, грозы). Город выбирает сервер
 * (/api/geo/city → App\Services\Geo\CityNamer): тот, у которого ЕСТЬ имя на
 * языке читателя. Прежняя ручка называла ближайшее поселение как есть, и на
 * 400 случайных точках суши (замер 08.10.2026) русская страница получала
 * латиницу в 57 % подписей, корейская — в 86 %, арабская — в 75 %, а
 * украинская не получала подписи вовсе: в том наборе не было украинских имён.
 *
 *   GeoCity.lookup(lat, lon, {mode, far})   → Promise<item | null>
 *   GeoCity.lookupMany(points, {mode, far}) → Promise<[item | null]>
 *   GeoCity.text(item, {distance, country}) → строка для человека ('' — нечего сказать)
 *   GeoCity.parts(item, {…})                → {arrow, name, dist} | null — то же по частям
 *   GeoCity.fill(el, lat, lon, {mode, far, empty, ok}) — подставить подпись в элемент
 *
 * mode: 'near' — имя выбранной точки (ближайший город в 40 км),
 *       'area' — подпись области (значимый город в 150 км).
 * far:  ответ и посреди океана — ближайший город на любом расстоянии; только
 *       вместе с distance, иначе подпись выдаст далёкий город за место.
 *
 * Запросы одного такта собираются в один (до восьми точек), ответ помнится на
 * странице, у запроса есть срок.
 */
(function (root) {
  'use strict';

  var AREA_KM = 150, REACH_KM = 400, MAX = 8, WAIT_MS = 12000;
  var ARROWS = ['↑', '↗', '→', '↘', '↓', '↙', '←', '↖'];
  var cache = {}, queue = {}, regionNames = null, kmFormat = null;

  function locale() {
    var l = (root.__LOCALE || (root.document && root.document.documentElement && root.document.documentElement.lang) || 'en');
    return String(l).slice(0, 2).toLowerCase();
  }
  function url() { return root.__GEO_CITY_URL || '/api/geo/city'; }

  /* Название страны по коду — средствами браузера, на языке страницы. */
  function country(cc) {
    if (!cc) return '';
    try {
      if (regionNames === null) regionNames = (root.Intl && Intl.DisplayNames) ? new Intl.DisplayNames([locale()], { type: 'region' }) : false;
      return regionNames ? (regionNames.of(cc) || '') : '';
    } catch (e) { return ''; }
  }

  /* «42 км» / «42km» / «42 كم» — цифры латиницей, как во всём остальном тексте карт. */
  function km(n) {
    n = Math.round(n);
    try {
      if (kmFormat === null) {
        var l = locale();
        kmFormat = (root.Intl && Intl.NumberFormat) ? new Intl.NumberFormat(l === 'ar' ? 'ar-u-nu-latn' : l, { style: 'unit', unit: 'kilometer', unitDisplay: 'short', maximumFractionDigits: 0 }) : false;
      }
      if (kmFormat) return kmFormat.format(n);
    } catch (e) { kmFormat = false; }
    var l2 = locale();
    return n + ' ' + (l2 === 'ru' || l2 === 'uk' ? 'км' : l2 === 'ar' ? 'كم' : 'km');
  }

  /**
   * Подпись для человека.
   *  distance — «↗ Город · 42 км»: точка к северо-востоку от города; ближе 2 км
   *             — просто имя. Город на любом расстоянии честен, когда расстояние
   *             названо.
   *  без него — только имя, и только город ближе 150 км: дальше он не «здесь»,
   *             и подпись — страна точки.
   *  country  — к городу добавить его СВОЮ страну («Кукута, Колумбия», даже
   *             если точка за границей).
   */
  function text(it, o) {
    var p = parts(it, o);
    return p ? (p.arrow ? p.arrow + ' ' : '') + p.name + (p.dist ? ' · ' + p.dist : '') : '';
  }
  /* То же по частям — для карты, которая рисует стрелку по-своему. null — сказать нечего. */
  function parts(it, o) {
    o = o || {};
    if (!it) return null;
    if (it.found && it.name && (o.distance || it.km <= AREA_KM)) {
      var name = it.name;
      if (o.country) {
        var own = country(it.cc);
        if (own && own !== it.name) name += ', ' + own;
      }
      var off = !!o.distance && it.km >= 2;
      return { arrow: off ? (ARROWS[it.dir] || '') : '', name: name, dist: off ? km(it.km) : '' };
    }
    // Страна точки; если её не нашлось, но город недалеко — страна города.
    var c = country(it.country || (it.found && it.km <= REACH_KM ? it.cc : ''));
    return c ? { arrow: '', name: c, dist: '' } : null;
  }

  function keyOf(lat, lon, mode, far) {
    // Имя точки — по клетке 0,01°, подпись области — 0,05°: так же округляет сервер.
    var step = mode === 'near' ? 100 : 20;
    return mode + (far ? '+' : '') + ':' + (Math.round(lat * step) / step).toFixed(2) + ',' + (Math.round(lon * step) / step).toFixed(2);
  }

  function request(group) {
    var pts = group.map(function (g) { return g.pt; }).join(';');
    var head = group[0];
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, WAIT_MS) : null;
    /* `r` — the server's CityNamer::VERSION. The answer is cached a day by the
       browser and the CDN under its URL; a rule change (4 — no country next to
       a disputed place, 30.10.2026) must not wait out yesterday's labels. */
    var q = url() + '?mode=' + head.mode + (head.far ? '&far=1' : '') + '&lang=' + encodeURIComponent(locale()) + '&r=4&pts=' + pts;
    return fetch(q, { credentials: 'omit', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) {
        clearTimeout(timer);
        var items = (d && d.items) || [];
        group.forEach(function (g, i) { g.resolve(items[i] || null); });
      })
      .catch(function () {
        clearTimeout(timer);
        // Сеть моргнула — следующий вопрос о той же точке спросит заново.
        group.forEach(function (g) { delete cache[g.key]; g.resolve(null); });
      });
  }

  function flush(bucket) {
    var list = queue[bucket] || [];
    delete queue[bucket];
    for (var i = 0; i < list.length; i += MAX) request(list.slice(i, i + MAX));
  }

  function lookup(lat, lon, o) {
    o = o || {};
    lat = +lat; lon = +lon;
    if (!isFinite(lat) || !isFinite(lon) || Math.abs(lat) > 90) return Promise.resolve(null);
    lon = ((lon + 180) % 360 + 360) % 360 - 180;
    var mode = o.mode === 'area' ? 'area' : 'near', far = !!o.far;
    var key = keyOf(lat, lon, mode, far);
    if (cache[key]) return cache[key];
    var bucket = mode + (far ? '+' : '');
    cache[key] = new Promise(function (resolve) {
      if (!queue[bucket]) {
        queue[bucket] = [];
        setTimeout(function () { flush(bucket); }, 0);
      }
      queue[bucket].push({ key: key, mode: mode, far: far, pt: lat.toFixed(3) + ',' + lon.toFixed(3), resolve: resolve });
    });
    return cache[key];
  }

  function lookupMany(points, o) {
    return Promise.all((points || []).map(function (p) { return lookup(p.lat, p.lon, o); }));
  }

  /**
   * Подставить подпись точки в элемент. ok() — точка всё ещё та (человек мог
   * выбрать другую, пока шёл ответ); empty — что показать, когда сказать нечего.
   */
  function fill(el, lat, lon, o) {
    o = o || {};
    var opts = { mode: o.mode || 'near', far: o.far !== false };
    return lookup(lat, lon, opts).then(function (it) {
      var node = typeof el === 'string' ? root.document.getElementById(el) : el;
      if (!node || (o.ok && !o.ok())) return '';
      var s = text(it, { distance: true, country: !!o.country });
      node.textContent = s || (o.empty != null ? o.empty : '');
      return s;
    });
  }

  root.GeoCity = { lookup: lookup, lookupMany: lookupMany, text: text, parts: parts, fill: fill, country: country, km: km };
})(typeof window !== 'undefined' ? window : this);
